<div class="align-items-center">
    @if(messageInfo && messageInfo.message){
        <div class="col-12 mb-3 p-0" [innerHTML]="messageInfo.message">
        </div>
    }

    @if(messageInfo && messageInfo.messageFrom && messageInfo.approveDenyMessage){
        <div class="font-bold m-0">
            {{messageInfo.messageFrom}}:
        </div>
        <div class="col-12 mb-3 p-0">
            <p>{{messageInfo.approveDenyMessage}}</p>
        </div>
    }

    <div class="flex justify-content-end gap-2">
        <p-button label="ok" (click)="confirm(true)" />
    </div>
    
</div>
